<template>
  <div>
    <Header v-if="$route.meta.showHeader" />
    <router-view />
    <!-- 通过路由元信息动态加载 -->
    <Footer v-if="$route.meta.showFooter" />
  </div>
</template>

<script>
// 引入Header与Footer非路由组件
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="less">
.upload-demo {
  .imgicon {
    display: inline-block;
    width: 20px;
    margin-bottom: -3px;
    height: 20px;
    background-size: 100% 100%;
    margin-right: 10px;
    &.imgicon-jpg {
      background-image: url(./assets/images/file-icons/jpeg.svg);
    }
    &.imgicon-png {
      background-image: url(./assets/images/file-icons/png.svg);
    }
    &.imgicon-video {
      background-image: url(./assets/images/file-icons/other.svg);
    }
    &.imgicon-docx {
      background-image: url(./assets/images/file-icons/word.svg);
    }
    &.imgicon-xlsx {
      background-image: url(./assets/images/file-icons/xls.svg);
    }
    &.imgicon-pptx {
      background-image: url(./assets/images/file-icons/ppt.svg);
    }
    &.imgicon-zip {
      background-image: url(./assets/images/file-icons/zip.svg);
    }
    &.imgicon-pdf {
      background-image: url(./assets/images/file-icons/pdf.svg);
    }
    &.imgicon-default {
      background-image: url(./assets/images/file-icons/other.svg);
    }
  }
}
[class^="el-"]{
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--regular-border-color);
  }
}
</style>
